export default __webpack_public_path__ + "static/progress-bar-loading-do-7683ad8a612e5ebdf7c142adb361d0a04120d0dcd8d404041142bff1a6f51ab2.png";